import TypeBubble from "../Components/TypeBubble";
import { getTimeWorkedOnText } from "../../helpers";

const ProjectBox = ({ name, type, starred, progress, active, onClick, onChangeStarred, onChangeContextMenu }) => {
  let boxStyles = [
    "w-80 px-6 py-4 rounded-xl mb-6 border-2 font-semibold shadow-lg cursor-pointer ",
  ];
  let progressStyles = [
    `absolute top-0 bg-indigo-500 h-2 rounded-full`,
  ];

  if(progress._Percentage){
    const progressClass = `w-${progress._Percentage}p`
    progressStyles.push(progressClass)
  }

  // Apply active classes for different themes
  if (active) {
    boxStyles.push("bg-indigo-50 border-indigo-300");
    boxStyles.push("dark:bg-primary-dark dark:border-indigo-500 ");
  } else {
    boxStyles.push("bg-white border-slate-100");
    boxStyles.push("dark:bg-primary-dark border-transparent");
  }

  // Worked on time text
  const timeWorkedOnLabel = getTimeWorkedOnText(progress._TimeWorkedOn);

  return (
    <div className={boxStyles.join(" ")} onClick={onClick} onContextMenu={onChangeContextMenu}>
      <div className="flex justify-between mb-3 ">
        <div className="flex justify-between flex-wrap w-full mr-3">
          {/* Title */}
          <div className="text-2xl font-semibold mr-2 mb-1 break-words">
            {name}
          </div>
          {/* Type */}
          <TypeBubble type={type} />
        </div>

        {/* Starred */}
        <div onClick={(e) => {
          e.stopPropagation()  
          onChangeStarred(!starred)
        }} className="text-xl self-start">
          {starred ? (
            <i className="fas fa-star text-[#FDE047]"></i>
          ) : (
            <i className="far fa-star text-[#FDE047]"></i>
          )}
        </div>
      </div>
      {/* Progress */}
      <div className="text-xl">
        {/* Label + Percentage */}
        <div className="flex justify-between align-center mb-2 text-lg">
          <div>Progress</div>
          <div>{progress._Percentage}%</div>
        </div>
        {/* Progress bar */}
        <div className="relative mb-5 ">
          <div className="absolute w-full border-2 border-indigo-500 h-2 rounded-full "></div>
          <div className={progressStyles.join(" ")}></div>
        </div>
        <div className="flex justify-between align-center mb-2 text-base">
          {/* Worked on time */}
          <p className="text-indigo-500">{timeWorkedOnLabel}</p>
          {/* Tasks Done */}
          <div className="flex">
            <p className="mr-1.5">{progress._Tasks._Done}</p>
            <p className="text-slate-500"> / {progress._Tasks._All}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectBox;
